module.exports = __webpack_public_path__ + "img/face-grimace.59aff4f1.svg";